/**
 * Detects if the current browser/device supports transparent background .mov videos
 * based on a defined whitelist
 *
 * Supported combinations:
 * - Safari on macOS
 * - Chrome on macOS
 * - Chrome on Android
 * - Safari on iOS (and Chrome, which uses WebKit on iOS)
 *
 * Not supported:
 * - Firefox on any OS
 * - Any browser on Windows
 */
export const supportsTransparentMov = (): boolean => {
  // Return false if navigator is not available (SSR)
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent.toLowerCase();

  // Check for Windows - not supported on any browser
  if (
    userAgent.includes('windows') ||
    userAgent.includes('win32') ||
    userAgent.includes('win64')
  ) {
    return false;
  }

  // Check for Firefox - not supported on any OS
  if (userAgent.includes('firefox')) {
    return false;
  }

  // Check for iOS devices (iPhone, iPad, iPod) - Safari supports transparent .mov
  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return true;
  }

  // Check for Android with Chrome
  if (userAgent.includes('android') && userAgent.includes('chrome')) {
    return true;
  }

  // Check for macOS
  if (userAgent.includes('macintosh') || userAgent.includes('mac os x')) {
    // Safari on macOS
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
      return true;
    }

    // Chrome on macOS
    if (userAgent.includes('chrome')) {
      return true;
    }
  }

  // Default to false for any other combination
  return false;
};
